/* eslint-disable no-mixed-operators */
import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { Icon, Carousel, message, Spin } from 'antd';
import TextEvents from 'app/components/TextEvents';
import BtnLoginContainer from 'app/containers/BtnLoginContainer/BtnLoginContainer';
import { useStyles, styles } from './LoginScreenStyle'
import ReCAPTCHA from 'react-google-recaptcha';
import GoogleLogin from 'react-google-login';
import Auth from 'config/auth';
import { useDispatch, useSelector } from 'react-redux';
import { PURGE } from 'redux-persist';
import '../../../components/NavMenu.css'
import { Radio, Modal } from 'antd';
import img1 from '../../../images/login/FOTO1.jpg';
import img2 from '../../../images/login/FOTO2.jpg';
import img3 from '../../../images/login/FOTO3.jpg';
import classNames from 'classnames';

const recaptchaRef = React.createRef();

const LogoCotemar = process.env.REACT_APP_URL_LOGO_COTEMAR;
const LogoHSEQ = process.env.REACT_APP_URL_LOGO_HSEQ;

// const win=window.screen.height;
const images = [
    { name: 'img1', src: img1 },
    { name: 'img2', src: img2 },
    { name: 'img3', src: img3 }
]

export default function LoginScreen(props) {

    const [modalSession, setModalSession] = useState(props.location.sesionExp ? true : false);
    const classes = useStyles();
    const dispatch = useDispatch();
    const year = new Date().getFullYear()
    const [recatcha, setRecatcha] = useState('');
    const [isClickSubmit, setClickSubmit] = useState(false);
    const [isAuthFicha, setAuthFicha] = useState(true);
    const [isSelected, setIsSelected] = useState(false);
    const [access, setAccess] = useState(5);
    const { isLoading } = useSelector(state => state.Auth);


    const [authData, setAuthData] = useState({
        username: '',
        password: '',
        recordNumber: '',
        email: '',
        reCaptcha: '',
        AppName: '',
        admissionDate: '',
        TypeCredential: 0,
        hasMinimumData: false,
        writing: false,
        isLoggingIn: false,
        disabled: true
    });
    useEffect(() => {
        dispatch({
            type: PURGE,
            key: 'root',
            result: () => {
                props.history.push('/');
            }
        });

    }, []);
    const login = (e, authLogin) => {
        setClickSubmit(true);
        if (((authData.username === '' || authData.password === '') && access !== 5) || ((authData.recordNumber === '' || authData.email === '' || authData.admissionDate === '') && access === 5))
            return false;

        if (process.env.REACT_APP_ENABLE_CAPTCHA === 'True') {
            if (recaptchaRef.current.getValue() === '') {
                message.error("Seleccione el reCAPTCHA");
                return false;
            }
        }

        authLogin({
            username: authData.username,
            password: authData.password,
            recordNumber: authData.recordNumber,
            email: authData.email,
            reCaptcha: recatcha,
            admissionDate: authData.admissionDate,
            // isAuthFicha: isAuthFicha,
            TypeCredential: access,
            tokenGoogle: ''
        })
    }

    const handleOnChange = (e, type) => {

        switch (type) {
            case 'user':
                setAuthData({ ...authData, username: e.target.value })
                break;
            case 'pass':
                setAuthData({ ...authData, password: e.target.value })
                break;
            case 'recordNumber':
                setAuthData({ ...authData, recordNumber: e.target.value })
                break;
            case 'admissionDate':
                setAuthData({ ...authData, admissionDate: e.target.value })
                break;
            case 'email':
                setAuthData({ ...authData, email: e.target.value })
                break;
            default:
        }
    }

    const keyPress = (e, auth) => {
        if (e.key === 'Enter') {
            login(e, auth)
        }
    }

    const keyPressDate = (e) => {
        let { value } = e.target;
        try {
            var fecha = value.split('-');
            if (fecha[0].length > 4) {
                fecha[0] = fecha[0].substring(0, 4);
                e.target.value = `${fecha[0]}-${fecha[1]}-${fecha[2]}`;
            }
        } catch (error) {

        }

    }

    const handleOnChangeSwitch = (e) => {
        // setAuthFicha(e);
        setAccess(e.target.value);
        setClickSubmit(false);
    }

    const handleOnChangeRecatcha = (e) => {
        let recaptchaValue = recaptchaRef.current.getValue();
        setRecatcha(recaptchaValue);
    }

    const authGoogle = (response, authLogin) => {

        authLogin({
            username: response.profileObj.email,
            email: response.profileObj.email,
            tokenGoogle: response.getAuthResponse().id_token,
            isAuthFicha: false,
            TypeCredential: 2//Google
        })
    }
    return (
        <Spin spinning={isLoading}>
            <Grid container component='main' className={classes.root}>
                <Grid item md={7} sm={12} xs={12} className ={classNames(classes.smallDevice, 'gridItemCarousel')}>

                    <Carousel autoplay style={{ height: '50px', width: '100%' }}>
                        {images.map(i => {
                            return <div key={i.name}>
                                <img style={styles.imgProp} alt={i.name} src={i.src} width={'100%'}></img>
                            </div>
                        })}
                    </Carousel>
                </Grid>
                <Grid item className={classes.dataSmall}>
                    <div className={classes.olas}>
                        <div>
                            <img
                                alt="example"
                                src={require("../../../assets/footer.png")}
                                style={{ width: ' 100%', height: '100%', position: 'absolute' }}
                            />
                        </div>
                        <div className={classes.content} style={styles.companyText}>
                            <div className={classes.poweredByTic}>
                                <span style={{ fontSize: '1.1em' }}><span style={{ fontWeight: 'bold' }}>Powered</span> by</span><span style={styles.ticText}> TIC</span>
                            </div>
                            <div>
                                <span style={{ color: '#666666', paddingRight: '10px' }}>
                                    Copyright © {year} COTEMAR S.A. de C.V. Todos los derechos reservados.
                                    Este sistema pertenece, es operado y monitoreado por Grupo Cotemar S.A. de C.V. y contiene información confidencial propiedad de Cotemar.
                                    Cualquier acceso o uso no autorizado a este sistema por la administración de Cotemar no será permitido y podrá ser reportado a las autoridades competentes y/o ser objeto de alguna acción civil.
                                    Si usted no está autorizado a accesar o usar este sistema, desconectese ahora.
                                </span>
                            </div>
                        </div>
                    </div>
                    <Grid item component={Container} elevation={6} className={classNames(classes.smallsmall, 'smallPadding')} >
                        <div style={styles.container}>
                            <div style={styles.box}>
                                <Grid xs={12} md={12} item >
                                    <div className={classes.iconStyle}>
                                        <img
                                            alt="example"
                                            src={require("../../assets/COTEMAR - HSEQ - COTEPLAY - LOGO V3-11.png")}
                                            style={{ width: ' 40%', height: '40%' }}
                                        />
                                    </div>
                                </Grid>
                                <TextEvents
                                    text='Login'
                                    color='cotemar'
                                    size='body'
                                    weight='label'
                                />
                            </div>
                            <Auth>
                                {(params) => {
                                    return <BtnLoginContainer history={props.history} login={params.logIn}>
                                        {(auth) => {
                                            return (
                                                <div className={classes.content}>
                                                    <Grid container direction='row'>
                                                        <Grid xs={12} md={12} item >
                                                            {access !== 5 ?
                                                                <TextField
                                                                    className={classes.textFieldStyle}
                                                                    id='input-with-icon-textfield'
                                                                    label={<span><Icon type='user' /> Usuario</span>}
                                                                    onFocus={e => setIsSelected(true)}
                                                                    onBlur={e => setIsSelected(true)}
                                                                    fullWidth
                                                                    onChange={e => handleOnChange(e, 'user')}
                                                                    error={authData.username === '' && isClickSubmit || auth.isError}
                                                                    helperText={authData.username === '' && isClickSubmit ? 'Campo requerido' : ''}
                                                                    value={authData.username}
                                                                />
                                                                :
                                                                <TextField
                                                                    className={classes.textFieldStyle}
                                                                    id='adornment-amount'
                                                                    label='Ficha Empleado'
                                                                    placeholder='Ficha Empleado'
                                                                    fullWidth
                                                                    onChange={e => handleOnChange(e, 'recordNumber')}
                                                                    error={authData.recordNumber === '' && isClickSubmit || auth.isError}
                                                                    helperText={authData.recordNumber === '' && isClickSubmit ? 'Campo requerido' : ''}
                                                                    value={authData.recordNumber}
                                                                />
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container direction='row'>
                                                        <Grid xs={12} item  >
                                                            {access !== 5 ?
                                                                <TextField
                                                                    className={classes.textFieldStyle}
                                                                    type='password'
                                                                    placeholder='Contraseña'
                                                                    id='adornment-amount'
                                                                    children='AYUDA'
                                                                    label={<span><Icon type="key" /> Contraseña</span>}
                                                                    fullWidth
                                                                    onChange={e => handleOnChange(e, 'pass')}
                                                                    error={authData.password === '' && isClickSubmit || auth.isError}
                                                                    helperText={authData.password === '' && isClickSubmit ? 'Campo requerido' : ''}
                                                                    value={authData.password}
                                                                    onKeyDown={e => keyPress(e, auth.submit)}
                                                                />
                                                                :
                                                                <TextField
                                                                    className={classes.textFieldStyle}
                                                                    fullWidth
                                                                    id='datetime-local'
                                                                    label='Fecha de Antigüedad'
                                                                    type='date'
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                    onChange={e => handleOnChange(e, 'admissionDate')}
                                                                    error={authData.admissionDate === '' && isClickSubmit || auth.isError}
                                                                    helperText={authData.admissionDate === '' && isClickSubmit ? 'Campo requerido' : ''}
                                                                    value={authData.admissionDate}
                                                                    onKeyUp={e => keyPressDate(e)}
                                                                />
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container direction='row'>
                                                        <Grid xs={12} item  >
                                                            {access == 5 ?
                                                                <TextField
                                                                    className={classes.textFieldStyle}
                                                                    type='email'
                                                                    id='adornment-amount'
                                                                    label='Email Personal'
                                                                    placeholder='Email'
                                                                    fullWidth
                                                                    onChange={e => handleOnChange(e, 'email')}
                                                                    error={authData.email === '' && isClickSubmit || auth.isError}
                                                                    helperText={authData.email === '' && isClickSubmit ? 'Campo requerido' : ''}
                                                                    value={authData.email}
                                                                    onKeyPress={e => keyPress(e, auth.submit)}
                                                                />
                                                                : ''
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container direction='row'>
                                                        <Grid xs={12} item  >
                                                            {/* <Switch
                                                            size="small"
                                                            id='checker'
                                                            checkedChildren={<Icon type='user' />}
                                                            unCheckedChildren={<Icon type='user' />}
                                                            checked={isAuthFicha}
                                                            onChange={e => handleOnChangeSwitch(e)}
                                                        />
                                                        <label htmlFor='checker' className={classes.switchStyle}
                                                        >{isAuthFicha ? 'Acceso Clásico' : 'Directorio Activo'}</label> */}
                                                            <Radio.Group onChange={handleOnChangeSwitch} value={access}>
                                                                <Radio value={1}>Directorio Activo</Radio>
                                                                <Radio value={0}>Clasico</Radio>
                                                                <Radio value={5}>Tipo Portal de Servicios</Radio>
                                                            </Radio.Group>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container direction='row' className={classes.textFieldStyleRecap}>
                                                        <Grid md={12} sm={6} xs={6} item >
                                                            {
                                                                process.env.REACT_APP_ENABLE_CAPTCHA === 'True' &&
                                                                <ReCAPTCHA
                                                                    style={{ transform: 'scale(0.8)', transformOrigin: '0 0' }}
                                                                    ref={recaptchaRef}
                                                                    sitekey={process.env.REACT_APP_SITEKEY_RECAPTCHA}
                                                                    onChange={e => handleOnChangeRecatcha(e)}
                                                                />
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container direction='row'>
                                                        <Grid xs={12} item  >
                                                            <Button
                                                                type='button'
                                                                fullWidth
                                                                variant='contained'
                                                                color='primary'
                                                                disabled={auth.isLoading}
                                                                className={classes.submit}
                                                                onClick={(e) => login(e, auth.submit)}
                                                                style={{ height: '40px' }}
                                                            >{auth.isLoading ? 'CARGANDO...' : 'ENTRAR'}</Button>
                                                            <GoogleLogin
                                                                clientId={process.env.REACT_APP_CLIENTID_GOOGLE}
                                                                buttonText={'Entrar con Google'}
                                                                onSuccess={(e) => authGoogle(e, auth.submit)}
                                                                // onFailure={responseGoogle}
                                                                cookiePolicy={'single_host_origin'}
                                                                disabled={auth.isLoading}
                                                                className={classes.signInButton}
                                                            />
                                                        </Grid>
                                                    </Grid>

                                                    <div style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        marginTop: "12px",
                                                        marginBottom: "40px",
                                                    }}>

                                                        <img src={LogoCotemar} style={{ width: "120px" }} />
                                                        <img src={LogoHSEQ} style={{ width: "100px" }} />
                                                    </div>


                                                </div>
                                            )
                                        }}
                                    </BtnLoginContainer>
                                }}
                            </Auth>


                            <Modal
                                destroyOnClose={true}
                                visible={modalSession}
                                width={'650px'}
                                centered={true}
                                closable={false}
                                footer={
                                    [

                                        <Button key="submit" type="primary" loading={false} onClick={() => setModalSession(false)}>
                                            Aceptar
                                        </Button>
                                    ]
                                }
                            >
                                <div style={{ textAlign: 'center' }}>
                                    <img
                                        alt="time"
                                        src={require("../../../assets/time.png")}
                                        style={{ width: '30%' }}
                                    />
                                    <h2>Tiempo de sesión expirado</h2>
                                    <p>Por seguridad hemos finalizado tu <br></br>
                                        sesión por inactividad</p>
                                </div>
                            </Modal>         



                        </div>
                    </Grid>
                </Grid>
            </Grid>
        </Spin>
    )
}
